// extracted by mini-css-extract-plugin
export var borderRadius = "_bv-4";
export var large = "_bv-3";
export var logoContainer = "_bv-0";
export var nameLogo = "_bv-2";
export var small = "_bv-1";